import { trackEvent } from "infra/helpers/event";

export enum PerfilEventsEnum {
  IniciarCadastro = "Perfil_IniciarCadastro",
  IniciarEdicao = "Perfil_IniciarEdicao",
  Criar = "Perfil_Criar",
  Atualizar = "Perfil_Atualizar",
  Excluir = "Perfil_Excluir",
  CancelarExclusao = "Perfil_CancelarExclusao",
  Ver = "Perfil_Ver",
}

export function verPerfil(id: string) {
  trackEvent(PerfilEventsEnum.Ver, { id });
}

export function iniciarCadastro() {
  trackEvent(PerfilEventsEnum.IniciarCadastro);
}

export function iniciarEdicao(id: string) {
  trackEvent(PerfilEventsEnum.Ver, { id });
  trackEvent(PerfilEventsEnum.IniciarEdicao, { id });
}

export function criar() {
  trackEvent(PerfilEventsEnum.Criar);
}

export function atualizar(id: string) {
  trackEvent(PerfilEventsEnum.Atualizar, { id });
}

export function excluir(id: string) {
  trackEvent(PerfilEventsEnum.Excluir, { id });
}

export function cancelarExclusao(id: string) {
  trackEvent(PerfilEventsEnum.CancelarExclusao, { id });
}

const PerfilEvents = {
  verPerfil,
  iniciarCadastro,
  iniciarEdicao,
  cancelarExclusao,
  criar,
  atualizar,
  excluir,
};

export default PerfilEvents;
